<template>
  <div>
    <Messages :messages="messages"/>
    <div class="container" v-if="existsRecord" v-cloak>
      <h2>Consulta de constancias de Liberación de Idioma</h2>
      <br/>
      <div class="bg-secondary text-white font-weight-bold px-3 py-2 rounded d-inline-block">
        Datos del alumno
      </div>
      <hr>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Matrícula:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.idEnrollment">
        </b-form-input>
      </b-form-group>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Nombre:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.studentName">
        </b-form-input>
      </b-form-group>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Carrera:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.program">
        </b-form-input>
      </b-form-group>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Folio:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.folio">
        </b-form-input>
      </b-form-group>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Tipo de examen:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.examType">
        </b-form-input>
      </b-form-group>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Puntaje:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.score">
        </b-form-input>
      </b-form-group>

      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Fecha de expedición:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      readonly
                      v-bind:value="recordData.issueDate">
        </b-form-input>
      </b-form-group>

      <div class="row">
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Messages from "../components/Messages.vue"

export default {

  components: {
    Messages
  },
  
  data: () => ({
    existsRecord: false,
    recordData: {},
    showLoader: false,
    messages: {
      info: "",
      error: "",
      warning: ""
    }
  }),

  computed: {
    ...mapGetters({
      record: "record/record",
    }),
  },

  mounted () {
    this.initialize()
  },

  methods: {
    initialize () {
      console.log("Record in URL" + this.$route.query.folio)
      this.showLoader = true,
      this.$store
            .dispatch("record/getRecordLanguageReleaseUser", this.$route.query.folio)
            .then((response) => {
              this.recordData = response
              this.existsRecord = response != null ? true : false
              this.showLoader = false
            })
            .catch( error => {
              console.log(error)
              this.messages.info = "Constancia no encontrada."
              this.existsRecord = false
              this.showLoader = false
            })
    },
  }
}
</script>